import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import PublicPage from "@/pages/PublicPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App retro-noise">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#fff",
            border: "2px solid #1A2A3A",
            borderRadius: "12px",
            boxShadow: "4px 4px 0px #1A2A3A",
            fontFamily: "Outfit, sans-serif",
            color: "#1A2A3A",
            fontWeight: 600,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
